import React, {useContext} from 'react';
import CreateAnnouncementModal from "./CreateAnnouncementModal";
import DeleteAnnouncementModal from "./DeleteAnnouncementModal";
import EditAnnouncementModal from "./EditAnnouncementModal";
import {WebAnnouncementsContext} from "../../pages/admin/webannouncements/context";
export default function AnnouncementModal() {
    const {announcements, setAnnouncements, show, setShow, showDelete, setShowDelete,
        showCreate, setShowCreate, showEdit, setShowEdit, selectedAnnouncement, setSelectedAnnouncement,
        announcementToBeDeleted, setAnnouncementToBeDeleted,} = useContext(WebAnnouncementsContext);
    const validateSubmission = (formErrors, announcement)=>{
        let errors = {}
        errors = {...formErrors}
        const {header, content, notification} = announcement;

        if(!header)
            errors['header'] = 'Please input Header text';

        if(!content)
            errors['content'] = 'Please input Body text';

        if(header.trim().length > 250)
            errors['header'] = 'Please limit your input to 250 characters or fewer';

        if(content.trim().length > 250)
            errors['content'] = 'Please limit your input to 250 characters or fewer';

        if(!notification)
            errors['notification'] = 'Please select notification type';

        return errors;
    }

            if(showCreate)
                return <CreateAnnouncementModal
                           show={show}
                           setShow={setShow}
                           showCreate={showCreate}
                           setShowCreate={setShowCreate}
                           announcements={announcements}
                           setAnnouncements={setAnnouncements}
                           validateSubmission={validateSubmission}
                />

            else if(showEdit)
                return <EditAnnouncementModal
                            show={show}
                            setShow={setShow}
                            showEdit={showEdit}
                            setShowEdit={setShowEdit}
                            announcements={announcements}
                            setAnnouncements={setAnnouncements}
                            selectedAnnouncement={selectedAnnouncement}
                            validateSubmission={validateSubmission}
                />
            else if(showDelete)
                return <DeleteAnnouncementModal
                            show={setShow}
                            setShow={setShow}
                            showDelete={showDelete}
                            setShowDelete={setShowDelete}
                            announcements={announcements}
                            setAnnouncements={setAnnouncements}
                            announcementToBeDeleted={announcementToBeDeleted}
                />

    }

